import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { Role } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, public router: Router, private configurationService: ConfigurationService, private readonly exceptionSolutionService: ExceptionSolutionService) {

  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let userRoles = Array.from(this.authService.readRolesInStorage());

    const routeAccessId = route.data.id ? route.data.id : null;
    const canProceed = this.authService.isAuthenticated() && this.haveAccess(routeAccessId) && this.belongsToThisBranch(userRoles);
    if (!canProceed) {
      this.exceptionSolutionService.showAlertWithSolution(`Acceso de usuario`, `No tiene permiso para acceder a este recurso.`);
      this.router.navigate(["login"]);
    } else if (
      this.authService.isAuthenticated() && userRoles.includes(Role.ROLE_ADMIN) && route.routeConfig && route.routeConfig.path != "config") {
      this.router.navigate(["config"]);
    }

    return true;
  }

  haveAccess(routeAccessId: string): boolean {
    let result = true;

    if (routeAccessId) {
      const accessList = Array.from(this.authService.readAccessInStorage());
      result = !!accessList && !!accessList.length && accessList.includes(routeAccessId);
    }

    return result
  }

  belongsToThisBranch(userRoles: Array<Role>): boolean {
    const userBranches = Array.from(this.authService.readBranchCodesInStorage());
    return userBranches.includes(this.configurationService.readSelectedBranchAndSalesOrg().branch.code) ||
      userRoles.includes(Role.ROLE_ADMIN);
  }

}
